import React from 'react';
import UpdateWindow from '../Components/UpdateWindow';

const Update = () => {
  return <UpdateWindow />;
};

export default Update; 